var map = {
	"./Share.svg": 4,
	"./arrow-down.svg": 5,
	"./arrow-left.svg": 6,
	"./arrow-right.svg": 7,
	"./arrow-up.svg": 8,
	"./bb-icon-v1.svg": 9,
	"./bb-icon-v2.svg": 10,
	"./bb-icon-v3.svg": 11,
	"./bb-icon-v4.svg": 12,
	"./bb-icon-v5.svg": 13,
	"./bb-icon-v6.svg": 14,
	"./bb-logo.svg": 15,
	"./brackets.svg": 16,
	"./code.svg": 17,
	"./code1.svg": 18,
	"./code2.svg": 19,
	"./envelope.svg": 20,
	"./flag.svg": 21,
	"./gm-icon.svg": 22,
	"./home.svg": 23,
	"./link.svg": 24,
	"./logo.svg": 25,
	"./mac-footer.svg": 26,
	"./pc.svg": 27,
	"./phone-icon.svg": 28,
	"./phone.svg": 29,
	"./sad.svg": 30,
	"./tablet.svg": 31,
	"./thumbnail.svg": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;